"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanPaymentFrequency = exports.PlanCostType = exports.ServiceType = void 0;
var ServiceType;
(function (ServiceType) {
    ServiceType["benefit"] = "benefit";
    ServiceType["activity"] = "activity";
    ServiceType["mode"] = "mode";
    ServiceType["program"] = "program";
    ServiceType["amenity"] = "amenity";
    ServiceType["carbonOffset"] = "carbon_offset";
})(ServiceType || (exports.ServiceType = ServiceType = {}));
var PlanCostType;
(function (PlanCostType) {
    PlanCostType["perUnit"] = "per_unit";
})(PlanCostType || (exports.PlanCostType = PlanCostType = {}));
var PlanPaymentFrequency;
(function (PlanPaymentFrequency) {
    PlanPaymentFrequency["monthly"] = "monthly";
    PlanPaymentFrequency["daily"] = "daily";
    PlanPaymentFrequency["annually"] = "annually";
    PlanPaymentFrequency["biweekly"] = "biweekly";
    PlanPaymentFrequency["weekly"] = "weekly";
    PlanPaymentFrequency["free"] = "free";
    PlanPaymentFrequency["variable"] = "variable";
})(PlanPaymentFrequency || (exports.PlanPaymentFrequency = PlanPaymentFrequency = {}));
//# sourceMappingURL=Routes.js.map